import React, { useState } from "react";
import "./BetPopup.css";

const BetPopup = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [amount, setAmount] = useState(1);
  const [quantity, setQuantity] = useState(1);
  const [activeMultiplier, setActiveMultiplier] = useState(null);
  const [activeAmount, setActiveAmount] = useState(null);
  const [activeQuantityChange, setActiveQuantityChange] = useState(null);

  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleAmountChange = (value) => {
    setAmount(value);
    setActiveAmount(value);
  };

  const handleQuantityChange = (value) => {
    if (quantity + value >= 1) {
      setQuantity(quantity + value);
      setActiveQuantityChange(value);
      setTimeout(() => setActiveQuantityChange(null), 300);
    }
  };

  const handleMultiplier = (multiplier) => {
    setQuantity(quantity * multiplier);
    setActiveMultiplier(multiplier);
  };

  return (
    <div>
      <div onClick={handleOpenPopup} style={{ cursor: "pointer" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            style={{
              backgroundColor: "#F0AD4E",
              color: "#fff",

              border: "none",
              borderRadius: "1px",
              padding: "10px 0px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            Big
          </button>
        </div>
      </div>

      {isPopupOpen && (
        <div className="main-popup-component">
          <div className="main2-popup">
            <div
              className="main2-popup-in"
              style={{
                background:
                  "linear-gradient(180deg, #0F9957  0%, #49C755 100%)",
                paddingBottom: "50px",
                paddingTop: "15px",
              }}
            >
              <div
                style={{
                  color: "#fff",
                  textAlign: "center",
                  fontWeight: "600",
                  fontSize: "25px",
                }}
              >
                Wingo
              </div>
              <div
                style={{ color: "#fff", textAlign: "center" }}
                className="choose-big-in"
              >
                Choose Big
              </div>
            </div>
            <div
              style={{
                padding: "40px 20px 0px 20px",
                borderTop: "1px solid #1AB266",
                marginTop: "3px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="bet-amount-text" style={{ color: "#6C757D" }}>
                  Amount
                </div>
                <div style={{ display: "flex", gap: "6px" }}>
                  {[1, 10, 100, 1000].map((value) => (
                    <div
                      key={value}
                      onClick={() => handleAmountChange(value)}
                      className="bet-amount-all"
                      style={{
                        backgroundColor:
                          activeAmount === value ? "#4CAF50" : "#1E2328",
                        color: activeAmount === value ? "#fff" : "#6C757D",
                        padding: "10px",
                        borderRadius: "1px",
                        cursor: "pointer",
                        fontWeight: "bold",
                      }}
                    >
                      {value}
                    </div>
                  ))}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <div className="bet-amount-text" style={{ color: "#6C757D" }}>
                  Quantity
                </div>
                <div style={{ display: "flex", gap: "6px" }}>
                  <div
                    className="bet-amount-remove"
                    onClick={() => handleQuantityChange(-1)}
                    style={{
                      backgroundColor:
                        activeQuantityChange === -1 ? "#4CAF50" : "#1E2328",
                      color: activeQuantityChange === -1 ? "#fff" : "#6C757D",

                      borderRadius: "1px",
                      cursor: "pointer",
                    }}
                  >
                    -
                  </div>
                  <div className="bet-amount-data">{quantity}</div>
                  <div
                    className="bet-amount-add"
                    onClick={() => handleQuantityChange(1)}
                    style={{
                      backgroundColor:
                        activeQuantityChange === 1 ? "#4CAF50" : "#1E2328",
                      color: activeQuantityChange === 1 ? "#fff" : "#6C757D",

                      borderRadius: "1px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    +
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "6px",
                  marginTop: "20px",
                }}
              >
                {[1, 5, 10, 20, 50, 100].map((multiplier) => (
                  <div
                    key={multiplier}
                    style={{
                      backgroundColor:
                        activeMultiplier === multiplier ? "#4CAF50" : "#1E2328",
                      color:
                        activeMultiplier === multiplier ? "#fff" : "#6C757D",

                      display: "flex",
                      height: "30px",
                      alignItems: "center",
                      width: "40px",
                      padding: "0px 10px",
                      justifyContent: "center",

                      borderRadius: "1px",
                      cursor: "pointer",

                      //   fontWeight: "bold",
                    }}
                    onClick={() => handleMultiplier(multiplier)}
                  >
                    X{multiplier}
                  </div>
                ))}
              </div>
            </div>

            <div style={{ display: "flex", marginTop: "50px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "hsla(0,0%,100%,.4)",

                  width: "100%",
                  background: "#25253c",
                  height: "50px",
                  fontWeight: "600",
                  fontSize: "1rem",
                  cursor: "pointer",
                }}
                onClick={handleClosePopup}
              >
                Cancel
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "600",
                  color: "#fff",
                  height: "50px",
                  fontSize: "1rem",

                  width: "100%",
                  background: "#4CAF50",
                }}
              >
                Total Amount: {amount * quantity}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BetPopup;
